import { render, staticRenderFns } from "./SendToApprovalModal.vue?vue&type=template&id=19f3f43c&"
import script from "./SendToApprovalModal.vue?vue&type=script&lang=ts&"
export * from "./SendToApprovalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports